































































































import { defineComponent, type PropType } from "vue-demi";
import GGGroup from "../GGGroup/GGGroup.vue";
import GGRowSlider from "../../grid-generation/GGRowSlider/GGRowSlider.vue";
import GGDiscountMarker from "../GGDiscountMarker.vue";
import getValueForProp from "../../../helper/getValueForProp";
import GGPrice from "../GGPrice.vue";
import type { PageData } from "@constructor/shared-entity/type";

export default defineComponent({
  name: "GGSaleItems",
  components: {
    GGGroup,
    GGRowSlider,
    GGPrice,
    GGDiscountMarker,
  },
  props: {
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
  },
  computed: {
    backgroundDesktop() {
      return (
        getValueForProp(
          "sectionBackgroundImageDesktop",
          this.data.template.prop
        ) || undefined
      );
    },
    backgroundMobile() {
      return (
        getValueForProp(
          "sectionBackgroundImageMobile",
          this.data.template.prop
        ) || undefined
      );
    },
    backgroundColor() {
      return (
        getValueForProp("sectionBackgroundColor", this.data.template.prop) ||
        undefined
      );
    },
  },
});
